import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { switchAll } from "rxjs";
import Swal from "sweetalert2";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { CloseScrollStrategy } from "@angular/cdk/overlay";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { EditorModule } from "@tinymce/tinymce-angular";
import {
  GENDER_OPTIONS,
  // TRACK_OPTIONS,
  SECTOR_OPTIONS,
  // STATE_OPTIONS,
  STATUS_OPTIONS,
  BOOL_OPTIONS,
  COUNTRY_OPTIONS,
} from "src/app/enums/registration_options";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-dashb",
  templateUrl: "./dashb.component.html",
  styleUrls: ["./dashb.component.scss"],
})
export class DashbComponent {
  @ViewChild("sidenav") sidenav: MatSidenav;
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  li: any;
  lis = [];
  lit: any;
  list = [];
  vis = [];
  id: any;
  upt: any;
  uptlis = [];
  name: any;
  eureka23id: any;
  firstFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFormGroup: FormGroup;
  // trackFormGroup: FormGroup;

  showReminder = false;
  constructor(
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}
  gender = GENDER_OPTIONS;
  status = STATUS_OPTIONS;
  country = COUNTRY_OPTIONS;
  // tracks = TRACK_OPTIONS;
  sector = SECTOR_OPTIONS;
  // states = STATE_OPTIONS;
  bool = BOOL_OPTIONS;

  ids: any;
  auth: any;
  displayStyles = "none";
  ngOnInit() {
    this.ids = localStorage.getItem("formFilled");
    this.auth = localStorage.getItem("authToken");
    if (this.auth == null) {
      Swal.fire("Login first to access dashboard");
      this.router.navigate(["/login"]);
    } else {
      this.router.navigate(["/db"]);
    }
    this.http.get(environment.API_URL + "getUpt/").subscribe((Response) => {
      console.log(Response);
      this.upt = Response;
      this.uptlis = this.upt.update;
    });
    this.fourthFormGroup = this._formBuilder.group({
      startup: ["", Validators.required],
      sector1: ["", Validators.required],
      sector2: ["", Validators.required],
      idea: ["", Validators.required],
      // registered: [""],
      // dpiit: [""],
      // track: ["", Validators.required],
    });
    // this.trackFormGroup = this._formBuilder.group({
    //   track: ["", Validators.required],
    // });
    this.buildFirstFormGroup();
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .get(environment.API_URL + "getIdeasMembers/", { headers })
      .subscribe((Response) => {
        // console.log(Response)
        this.li = Response;
        this.lis = this.li.all_idea;
      });
    this.http
      .get(environment.API_URL + "getMemb/", { headers })
      .subscribe((Data) => {
        this.lit = Data;
        this.list = this.lit.all_memb;
        this.eureka23id = this.lit.eureka_id;
        // console.log(this.lit)
      });
  }
  ngAfterViewInit() {
    this.fireReminder();
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  // prelsub(id: any, name: any, track: any) {
  //   // console.log(id)
  //   if (environment.REGISTRATIONS_CLOSED) {
  //     Swal.fire("Registration has been closed!");
  //     return;
  //   }
  //   localStorage.setItem("tempid", id);
  //   localStorage.setItem("preltrack", track);
  //   console.log(localStorage.getItem("tempid"));
  //   localStorage.setItem("prelname", name);
  //   this.router.navigateByUrl("/idea");
  // }

  prelsub(id: any, name: any) {
    // console.log(id)
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    localStorage.setItem("tempid", id);
    // localStorage.setItem("preltrack", track);
    console.log(localStorage.getItem("tempid"));
    localStorage.setItem("prelname", name);
    this.router.navigateByUrl("/idea");
  }
  displayStyle = "none";
  idea_ids: any;
  memb_ids: any;
  // track_ids: any;
  aid: any;
  aname: any;
  // atrack: any;
  asecA: any;
  asecB: any;
  adesc: any;
  bname: any;
  bcontact: any;
  bemail: any;
  bgender: any;
  bctry: any;
  // bstate: any;
  // bcity: any;
  // aisReg: any;
  displayStyle2 = "none";
  displayStyle3 = "none";
  displayStyle4 = "none";
  displayStyleMember = "none";
  displayStyle5 = "none";
  displayStyle6 = "none";
  displayStyle7 = "none";
  openPopup() {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle = "block";
    this.fourthFormGroup = this._formBuilder.group({
      startup: ["", Validators.required],
      sector1: ["", Validators.required],
      sector2: ["", Validators.required],
      // track: ["", Validators.required],
      idea: ["", Validators.required],
      // dpiit: [""],
      // registered: ["", Validators.required],
    });
  }
  openPopup2() {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle2 = "block";
  }
  openPopup3(id: any, name: any, secA: any, secB: any, desc: any, isReg: any) {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle3 = "block";
    this.idea_ids = id;
    this.fourthFormGroup = this._formBuilder.group({
      startup: [name, Validators.required],
      // track: [track, Validators.required],
      dpiit: [""],
      sector1: [secA, Validators.required],
      sector2: [secB, Validators.required],
      idea: [desc, Validators.required],
      // registered: [isReg, Validators.required],
    });
  }
  memberdetails(
    id: any,
    name: any,
    email: any,
    contact: any,
    gender: any,
    // state: any,
    // city: any,
    // profState: any
  ) {
    this.displayStyleMember = "block";
    this.bname = name;
    this.bemail = email;
    this.bcontact = contact;
    this.bgender = gender;
    // this.bctry = ctry
    // this.bstate = state;
    // this.bcity = city;
  }
  openPopup5(
    id: any,
    name: any,
    email: any,
    contact: any,
    gender: any,
    // state: any,
    // city: any,
    // profStat: any
  ) {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle5 = "block";
    this.memb_ids = id;
    this.buildFirstFormGroup({
      name,
      email,
      contact,
      gender,
      // state,
      // city,
      // status: profStat,
    });
  }
  openPopup4(id: any, name: any, secA: any, secB: any, desc: any, isReg: any) {
    this.displayStyle4 = "block";
    this.aid = id;
    this.aname = name;
    // this.atrack = track
    this.asecA = secA;
    this.asecB = secB;
    this.adesc = desc;
    // this.aisReg = isReg;
  }
  openPopup6(id: any) {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle6 = "block";
    // this.track_ids = id;
  }
  // openPopup7(id: any, track: any) {
  //   if (environment.REGISTRATIONS_CLOSED) {
  //     Swal.fire("Registration has been closed!");
  //     return;
  //   }
  //   this.displayStyle7 = "block";
  //   this.track_ids = id;
  //   this.trackFormGroup = this._formBuilder.group({
  //     track: [track, Validators.required],
  //   });
  // }
  openPopup7(id: any) {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been closed!");
      return;
    }
    this.displayStyle7 = "block";
    // this.track_ids = id;
    // this.trackFormGroup = this._formBuilder.group({
    //   track: [track, Validators.required],
    // });
  }
  closePopup() {
    this.displayStyle = "none";
  }
  closePopup6() {
    this.displayStyle6 = "none";
  }
  closePopup7() {
    this.displayStyle7 = "none";
  }
  closePopupMember() {
    this.displayStyleMember = "none";
    this.bname = "";
    this.bemail = "";
    this.bcontact = "";
    this.bgender = "";
    this.bctry = "";
    // this.bstate = "";
    // this.bcity = "";
  }
  closePopup2() {
    this.displayStyle2 = "none";
  }
  closePopup3() {
    this.displayStyle3 = "none";
    this.fourthFormGroup = this._formBuilder.group({
      startup: ["", Validators.required],
      // track: ["", Validators.required],
      sector1: ["", Validators.required],
      sector2: ["", Validators.required],
      idea: ["", Validators.required],
      // dpiit: [""],
      // registered: ["", Validators.required],
    });
  }
  closePopup4() {
    this.displayStyle4 = "none";
    this.aname = "";
    // this.atrack = ''
    this.asecA = "";
    this.asecB = "";
    this.adesc = "";
    // this.aisReg = "";
  }
  closePopup5() {
    this.displayStyle5 = "none";
    this.buildFirstFormGroup();
  }

  submit() {
    if (this.firstFormGroup.valid) {
      this.displayStyles = "block";
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("name", this.firstFormGroup.value.name);
      body.append("email", this.firstFormGroup.value.email);
      body.append("contact", this.firstFormGroup.value.contact);
      // body.append('ctry', this.firstFormGroup.value.country);
      // body.append("state", this.firstFormGroup.value.state);
      // body.append("city", this.firstFormGroup.value.city);
      body.append("gender", this.firstFormGroup.value.gender);
      // body.append("profStat", this.firstFormGroup.value.status);
      this.http
        .post<any>(environment.API_URL + "addMemb/", body, { headers })
        .subscribe(
          (data) => {
            Swal.fire(data.status);
            this.displayStyle2 = "none";
            const headers = {
              Authorization: "Token " + localStorage.getItem("authToken"),
            };
            this.http
              .get(environment.API_URL + "getMemb/", { headers })
              .subscribe((Data) => {
                this.lit = Data;
                this.list = this.lit.all_memb;
                this.buildFirstFormGroup();
              });
            this.displayStyles = "none";
          },
          (error) => {
            this.displayStyles = "none";
            Swal.fire("EmailID already Registered");
            this.buildFirstFormGroup();
          }
        );
    } else {
      Swal.fire("Fill all the details correctly");
      for (const controlName in this.firstFormGroup.controls) {
        const control1 = this.firstFormGroup.get(controlName);
        if (control1?.invalid) {
          console.log(`Invalid control: ${controlName}`);
        }
      }
    }
  }

  buildFirstFormGroup(options?: any) {
    this.firstFormGroup = this._formBuilder.group({
      name: [options?.name ?? "", Validators.required],
      email: [
        {
          value: options?.email ?? "",
          disabled: options?.email ? true : false,
        },
        Validators.compose([Validators.required, Validators.email]),
      ],
      // country: ['', Validators.required],
      // state: [options?.state ?? "", Validators.required],
      // city: [options?.city ?? "", Validators.required],
      contact: [
        options?.contact ?? "",
        Validators.compose([Validators.required, Validators.min(10)]),
      ],
      gender: [options?.gender ?? "", Validators.required],
      // status: [options?.status ?? "", Validators.required],
    });
  }

  submit2() {
    if (this.fourthFormGroup.valid) {
      this.displayStyles = "block";
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("name", this.fourthFormGroup.value.startup);
      body.append("desc", this.fourthFormGroup.value.idea);
      // body.append("track", this.fourthFormGroup.value.track);
      body.append("secA", this.fourthFormGroup.value.sector1);
      body.append("secB", this.fourthFormGroup.value.sector2);
      // body.append("isReg", this.fourthFormGroup.value.registered);
      // body.append("dpiit", this.fourthFormGroup.value.dpiit);
      this.http
        .post<any>(environment.API_URL + "addIdea/", body, { headers })
        .subscribe((data) => {
          Swal.fire("Idea Added Succesfully!");

          this.displayStyle = "none";
          const headers = {
            Authorization: "Token " + localStorage.getItem("authToken"),
          };
          this.http
            .get(environment.API_URL + "getIdeasMembers/", { headers })
            .subscribe((Response) => {
              this.li = Response;
              this.lis = this.li.all_idea;

              this.displayStyles = "none";
            });
        });
    } else {
      Swal.fire("Fill all the details correctly");
    }
  }

  fireReminder() {
    this.showReminder = true;
    // Swal.fire({
    //   title: "Reminder!",
    //   text: "It's compulsory for you to fill the preliminary submission and choose the track for your idea to take part in further evaluation process.",
    //   position: "top",
    //   grow: "row",
    //   toast: true,
    //   background: "#FFF9E7",
    //   customClass: {
    //     container: "custom-swal-container",
    //   },

    //   showConfirmButton: false,
    //   showCloseButton: true,
    // });
  }

  // Track Submission Function

  // submittrack(id: any) {
  //   if (this.trackFormGroup.valid) {
  //     this.displayStyle6 = "block";
  //     const headers = {
  //       Authorization: "Token " + localStorage.getItem("authToken"),
  //     };
  //     var body: any = new FormData();
  //     body.append("id", id);
  //     body.append("track", this.trackFormGroup.value.track);
  //     this.http
  //       .post<any>(environment.API_URL + "addTrack/", body, {
  //         headers,
  //       })
  //       .subscribe((data) => {
  //         Swal.fire("Track Added Succesfully!");
  //         window.location.reload();
  //         this.closePopup6();
  //       });
  //   } else {
  //     Swal.fire("Fill all the details correctly");
  //   }
  // }

  // Track Submission Edit Function

  // edittrack(id: any) {
  //   if (this.trackFormGroup.valid) {
  //     this.displayStyle7 = "block";
  //     const headers = {
  //       Authorization: "Token " + localStorage.getItem("authToken"),
  //     };
  //     var body: any = new FormData();
  //     body.append("id", id);
  //     body.append("track", this.trackFormGroup.value.track);
  //     this.http
  //       .post<any>(environment.API_URL + "editTrack/", body, {
  //         headers,
  //       })
  //       .subscribe(
  //         (data) => {
  //           Swal.fire(data.status);
  //           window.location.reload();
  //           this.closePopup7();
  //         },
  //         (error: HttpErrorResponse) => {
  //           Swal.fire(error.error.status);
  //           this.closePopup7();
  //         }
  //       );
  //   } else {
  //     Swal.fire("Fill all the details");
  //   }
  // }

  submit3(id: any) {
    if (this.fourthFormGroup.valid) {
      this.displayStyles = "block";
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("id", id);
      body.append("name", this.fourthFormGroup.value.startup);
      body.append("desc", this.fourthFormGroup.value.idea);
      // body.append('track', this.fourthFormGroup.value.track);
      body.append("secA", this.fourthFormGroup.value.sector1);
      body.append("secB", this.fourthFormGroup.value.sector2);
      // body.append("isReg", this.fourthFormGroup.value.registered);
      // body.append("dpiit", this.fourthFormGroup.value.dpiit);
      this.http
        .post<any>(environment.API_URL + "editIdea/", body, {
          headers,
        })
        .subscribe((data) => {
          this.closePopup3();
          Swal.fire(data.status);
          const headers = {
            Authorization: "Token " + localStorage.getItem("authToken"),
          };
          this.http
            .get(environment.API_URL + "getIdeasMembers/", { headers })
            .subscribe((Response) => {
              this.li = Response;
              this.lis = this.li.all_idea;
              this.displayStyles = "none";
            });
          this.fourthFormGroup = this._formBuilder.group({
            startup: ["", Validators.required],
            // track: ["", Validators.required],
            sector1: ["", Validators.required],
            sector2: ["", Validators.required],
            idea: ["", Validators.required],
            // dpiit: [""],
            // registered: ["", Validators.required],
          });
          this.displayStyles = "none";
        });
      this.displayStyles = "none";
    } else {
      Swal.fire("Fill all the details correctly");
    }
  }
  submit5(id: any) {
    if (this.firstFormGroup.valid) {
      this.displayStyles = "block";
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("id", id);
      console.log(id);
      body.append("name", this.firstFormGroup.value.name);
      body.append("email", this.firstFormGroup.value.email);
      body.append("contact", this.firstFormGroup.value.contact);
      // body.append('ctry', this.firstFormGroup.value.country);
      // body.append("state", this.firstFormGroup.value.state);
      // body.append("city", this.firstFormGroup.value.city);
      body.append("gender", this.firstFormGroup.value.gender);
      // body.append("profStat", this.firstFormGroup.value.status);
      this.http
        .post<any>(environment.API_URL + "editMemb/", body, {
          headers,
        })
        .subscribe(
          (data) => {
            Swal.fire(data.status);
            this.closePopup5();
            const headers = {
              Authorization: "Token " + localStorage.getItem("authToken"),
            };
            this.http
              .get(environment.API_URL + "getMemb/", { headers })
              .subscribe((Response) => {
                this.li = Response;
                this.list = this.li.all_memb;
                console.log(this.list);
                this.displayStyle = "none";
              });
            this.firstFormGroup = this._formBuilder.group({
              name: ["", Validators.required],
              email: [
                "",
                Validators.compose([Validators.required, Validators.email]),
              ],
              // country: ['', Validators.required],
              // state: ["", Validators.required],
              // city: ["", Validators.required],
              contact: [
                "",
                Validators.compose([Validators.required, Validators.min(10)]),
              ],
              gender: ["", Validators.required],
              // status: ["", Validators.required],
            });
            this.displayStyles = "none";
          },
          (error: HttpErrorResponse) => {
            this.displayStyles = "none";
            Swal.fire("Some error ocurred pls contact admin");
          }

        );
    } else {
      Swal.fire("Fill all the details correctly - edit member error");
    }
  }
  deletemember(id: any, name: any, email: any) {
    Swal.fire({
      icon: "warning",
      title: "Do you want to delete this member?",
      text: "Name: " + name + ", Email: " + email,
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete this user",
      // denyButtonText: `Don't save`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.displayStyles = "block";
        var body: any = new FormData();
        body.append("id", id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "deletememberxyz/", body, {
            headers,
          })
          .subscribe(
            (data) => {
              this.displayStyles = "none";
              Swal.fire(data.status);
              const headers = {
                Authorization: "Token " + localStorage.getItem("authToken"),
              };
              this.http
                .get(environment.API_URL + "getMemb/", { headers })
                .subscribe((Response) => {
                  this.li = Response;
                  this.list = this.li.all_memb;
                });
            },
            (error: HttpErrorResponse) => {
              console.log(error);
              this.displayStyles = "none";
              Swal.fire("Member with this EmailID already exists");
            }
          );
      } else if (result.isDenied) {
        Swal.fire("User not deleted", "", "info");
      }
    });
  }
  deleteidea(id: any, name: any) {
    Swal.fire({
      icon: "warning",
      title: "Do you want to delete this idea?",
      text: "Name: " + name,
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete this idea",
      // denyButtonText: `Don't save`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.displayStyles = "block";
        var body: any = new FormData();
        body.append("id", id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "deleteideaxyz/", body, {
            headers,
          })
          .subscribe(
            (data) => {
              this.displayStyles = "none";
              this.closePopup4();
              Swal.fire(data.status);
              const headers = {
                Authorization: "Token " + localStorage.getItem("authToken"),
              };
              this.http
                .get(environment.API_URL + "getIdeasMembers/", { headers })
                .subscribe((Response) => {
                  this.li = Response;
                  this.lis = this.li.all_idea;
                });
            },
            (error: HttpErrorResponse) => {
              console.log(error);
              this.displayStyles = "none";
              Swal.fire("This idea can't be deleted");
            }
          );
        // Swal.fire('Saved!', '', 'success')
      } else if (result.isDenied) {
        Swal.fire("This idea can't be deleted");
      }
    });
  }
}
